export default {
    listagem: {
        titulo_pagina: 'Lista de Valores de Resultados',
        novo: 'crear Nuevo Valor',
        habilitado: 'Capaz',
        desabilitado: 'Desactivado',
        table: {
            empty: 'No se encontró ningún valor',
            nome: 'Nombre',
            codigo: 'Código',
            editar: 'Editar'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Crear Nuevo Valor de Resultado',
            editar: 'Editar Valor de Resultado'
        },
        fields: {
            codigo: {
                label: 'Código',
                description: 'Código de Valor'
            },
            nome: {
                label: 'Nombre',
                description: 'Nombre de Valor'
            },
            status: {
                label: 'Estado',
                description: 'Valor estado activo o inactivo'
            },
            botao_salvar : 'Guardar Valor'
        },
        create: {
            success: '¡Valor creado con éxito!',
            error: '¡Error al crear valor!'
        },
        update: {
            success: '¡Valor editado con éxito!',
            error: '¡Error al editar el valor!'
        }
    }
}
